import React, {
  useMemo,
  useState,
  useCallback,
} from 'react'

import {
  Button,
} from '@usap/uicomponents'

import { usePopUpContext } from '../../../../../../providers/PopUpProvider'
import useWmoEnabled from '../../../../../../../../hooks/useWmoEnabled'
import ButtonWmo from '../../../../../../../Wmo/ButtonWmo/ButtonWmo'

const Notify = () => {
  const {
    shouldShowOosProducts,
    shouldShowOosNotifyForm,
  } = usePopUpContext()

  const isWmoEnabled = useWmoEnabled()

  const [isProcessing, setIsProcessing] = useState(false)
  const buttonLabel = useMemo(
    () => {
      if (isProcessing) return 'Sending...'
      return isWmoEnabled ? 'Notify Me When Available' : 'Notify me when available'
    },
    [isProcessing, isWmoEnabled],
  )

  const handleNotify = useCallback(
    () => {
      setIsProcessing(true)
      shouldShowOosProducts(false)
      shouldShowOosNotifyForm(true)
    },
    [
      setIsProcessing,
      shouldShowOosProducts,
      shouldShowOosNotifyForm,
    ],
  )

  if (isWmoEnabled) {
    return (
      <ButtonWmo
        disabled={isProcessing}
        label={buttonLabel}
        onClick={handleNotify}
      />
    )
  }

  return (
    <Button
      custom
      hideBorder={false}
      disabled={isProcessing}
      label={buttonLabel}
      onClick={handleNotify}
    />
  )
}

export default Notify
